/** Normalises a user-entered promotion link. Returns null unless it is a valid http(s) URL. */
export function normalizePromoUrl(input: string): string | null {
  const raw = input.trim();
  if (!raw) return null;
  try {
    const url = new URL(/^[a-z]+:\/\//i.test(raw) ? raw : `https://${raw}`);
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    if (!url.hostname.includes(".")) return null;
    return url.toString();
  } catch {
    return null;
  }
}

/** Reads the external boost link stored on a promotion post's tags. */
export function promotionLink(tags?: string[] | null): string | null {
  const tag = tags?.find((t) => t.startsWith("link:"));
  return tag ? normalizePromoUrl(tag.slice(5)) : null;
}

export const isHiddenTag = (t: string) => t.startsWith("reshare:") || t.startsWith("placement:") || t.startsWith("link:") || t.startsWith("music:") || t.startsWith("boost:") || t.startsWith("pending-placement:");

export const isBoostTag = (t: string) => t.startsWith("boost:") || t.startsWith("pending-placement:");

/** Boost pricing works like Meta / Google ads: a daily budget times the number of days. */
export const BOOST_MIN_DAILY = 20;
export const boostTotal = (daily: number, days: number) => Math.round(daily * days);
/** Rough estimated people reached per rand, shown as a range like ad platforms do. */
export const boostReach = (daily: number, days: number) => ({ low: Math.round(daily * days * 40), high: Math.round(daily * days * 110) });

/** True when a promotion should show in `where` right now: placed there and, if paid, not expired. */
export function isPlacedIn(tags: string[] | null | undefined, where: "feed" | "trending", now = Date.now()): boolean {
  if (!tags?.includes(`placement:${where}`)) return false;
  const until = tags.find((t) => t.startsWith("boost:until:"));
  return !until || new Date(until.slice(12)).getTime() > now;
}
